import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "eraser",
  "use": "eraser-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"icon icon-tabler icon-tabler-eraser\" viewBox=\"0 0 24 24\" id=\"eraser\"><path stroke=\"none\" d=\"M0 0h24v24H0z\" /><path d=\"M19 19H8l-4-4a1 1 0 0 1 0-1.41l10-10a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 0 1.41l-9 9M18 12.3 11.7 6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbolimport SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "eraser",
  "use": "eraser-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" class=\"icon icon-tabler icon-tabler-eraser\" viewBox=\"0 0 24 24\" id=\"eraser\"><path stroke=\"none\" d=\"M0 0h24v24H0z\" /><path d=\"M19 19H8l-4-4a1 1 0 0 1 0-1.41l10-10a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 0 1.41l-9 9M18 12.3 11.7 6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol